<template>
  <div class="exam-detail" ref="examDetail">
    <div v-for="(exercise, index) in exercises" :key="index" ref="exam">
      <component
        :is="quizzes[exercise.code]"
        :exercise="exercise"
        :is-done="true"
        :is-exam="true"
        :is-show-number="true"
        :is-show-explain="true"
        :index="index"
        :user-answer="userAnswer[index]">
      </component>
    </div>
  </div>
</template>

<script>
import DX from './DX.vue';
import BQ from './BQ.vue';

export default {
  props: {
    exercises: {
      type: Array,
      default: () => [],
    },
    userAnswer: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      quizzes: {
        DX,
        BQ,
      },
    };
  },
  methods: {
    setAnchor(index) {
      const el = this.$refs.exam[index];
      this.$refs.examDetail.scrollTop = el ? el.offsetTop : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  .exam-detail {
    height: 100%;
    overflow-y: scroll;
  }
</style>
